import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {fetchFreqSuccess, fetchFreqError, updateFreqSuccess, updateFreqError } from '../actions/Freq';
import { getDocs, updateDoc } from 'firebase/services/freq';
import {FETCH_FREQ, UPDATE_FREQ} from 'constants/ActionTypes';

function* fetchFreqRequest() {
  try {
    const fetchedFreqList = yield call(getDocs);
    yield put(fetchFreqSuccess(fetchedFreqList));
  } catch (error) {
    console.log(error);
    yield put(fetchFreqError(error));
  }
}

function* updateFreqRequest({ params }) {
  try {
    const requests = params.map(param => call(updateDoc, {key: param.key, data: param}));
    const result = yield all(requests);
    yield put(updateFreqSuccess(result));
  } catch (error) {
    console.log(error);
    yield put(updateFreqError(error));
  }
}

export function* fetchFreq() {
  yield takeEvery(FETCH_FREQ, fetchFreqRequest);
}

export function* updateFreq() {
  yield takeEvery(UPDATE_FREQ, updateFreqRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchFreq), fork(updateFreq)]);
}
